import React, { useState } from 'react';
import 'tailwindcss/tailwind.css';

import landing from "../../../../../images/stupid-comedy-bg3.jpg";
import promorVideo from "../../../../../images/banner stupid comedy 1.mp4"; 
import { useNavigate } from 'react-router-dom';

export const HeroSection = () => {
    const navigate = useNavigate();
    const [isVideoLoading, setIsVideoLoading] = useState(true);
    const [videoError, setVideoError] = useState(false);
    
    return (
      <section 
        className="relative py-8 md:py-16 lg:py-20 w-full h-auto min-h-fit md:min-h-[720px] overflow-hidden"
      >
        {/* Imagen de fondo */}
        <div className="absolute inset-0">
          <img 
            src={landing} 
            alt="Background" 
            className="w-full h-full object-cover opacity-80" 
          />
          {/* Overlay para mejorar legibilidad del texto */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black/80"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 h-full">
          <div className="flex flex-col items-center justify-center h-full">
            {/* Contenido central: Video, Texto y CTA */}
            <div className="w-full max-w-3xl flex flex-col items-center">
              <div className="bg-black/50 backdrop-blur-sm p-4 md:p-6 rounded-xl rgb-border w-full flex flex-col items-center">
                {/* Video en lugar del logo */}
                <div className="video-container w-full aspect-video bg-black/20 backdrop-blur-sm relative overflow-hidden rounded-lg mb-4 md:mb-8">
                  {isVideoLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/50 z-10">
                      <div className="w-10 h-10 md:w-12 md:h-12 border-4 border-t-4 border-gray-200 border-t-red-600 rounded-full animate-spin"></div>
                    </div>
                  )}
                  
                  {videoError && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/70 text-white text-center p-4 z-10">
                      <div>
                        <p className="text-base md:text-lg font-medium mb-2">Error al cargar el video</p>
                        <p className="text-xs md:text-sm text-gray-300">Por favor, intenta más tarde</p>
                      </div>
                    </div>
                  )}
                  
                  <video 
                    className="w-full h-full object-cover" 
                    autoPlay 
                    muted 
                    loop
                    controlsList="nodownload" 
                    onContextMenu={(e) => e.preventDefault()}
                    onLoadStart={() => setIsVideoLoading(true)}
                    onLoadedData={() => setIsVideoLoading(false)}
                    onError={(e) => {
                      console.error('Error de video:', e);
                      setVideoError(true);
                      setIsVideoLoading(false);
                    }}
                    playsInline // Mejora reproducción en móviles
                  >
                    <source src={promorVideo} type="video/mp4" />
                    Tu navegador no soporta videos.
                  </video>
                </div>
                
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 md:mb-4 text-center">
                  Tu dosis diaria de risas
                </h2>
                <p className="mt-1 md:mt-2 mb-4 md:mb-6 text-white text-base md:text-lg lg:text-xl text-center">
                  Shows de stand-up, streaming y venta de entradas.
                </p>
                
                <div className="text-center w-full mb-2">
                  <button 
                    className="bg-red-600 hover:bg-red-700 transition-all duration-300 text-white py-3 px-6 md:px-8 rounded-lg text-lg md:text-xl font-medium transform hover:scale-105 shadow-lg hover:shadow-red-500/50 w-full md:w-4/5 max-w-xs mx-auto"
                    onClick={() => navigate("/login")}>
                    Empieza a reír ahora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};